import Vue from 'vue'
import VueI18n from 'vue-i18n'
import store from './store'

Vue.use(VueI18n)

function loadLocaleMessages () {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
  const messages = {}
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i)
    if (matched && matched.length > 1) {
      const locale = matched[1]
      messages[locale] = locales(key)
    }
  })
  return messages
}

const messages = loadLocaleMessages()

const locales = Object.keys(messages)

let lang = navigator.language || navigator.userLanguage

lang = (lang.substr(0, 2)).toLowerCase()

if (locales.indexOf(lang) === -1) {
  lang = 'en'
}

if (localStorage.getItem('lang')) {
  lang = localStorage.getItem('lang')
}

store.dispatch('setLanguage', lang)

export default new VueI18n({
  locale: lang || 'en',
  fallbackLocale: lang || 'en',
  messages: messages
})
